<template>
  <div class="payView">
    <el-dialog :visible.sync="payDialogVisible" :close-on-click-modal="false" width="700px" class="payDialog">
      <div class="center mt-10 color33 posr mb60">
        <div>
          <p class="fontw font16">收款方：福建大泽网络科技有限公司</p>
        </div>
        <div class="payInfo mt40 dfcjc">
          <div class="tc">
            <p class="font12">扫一扫付款（元）</p>
            <p class="font30 redFont">{{ cost }}</p>
            <div class="scanDiv">
              <p v-loading="loading" :class="loading ? 'scanDivLoading' : ''">
                <img :src="imageFwQrcode" alt style="width:168px;height:168px;" />
                <img
                  src="@/assets/payment.png"
                  alt=""
                  style="position: absolute;top: 55%;left: 50%;transform: translate(-50%,-50%);"
                />
                <span style="position: absolute;top: 58%;color: #999;" v-if="loading">加载中...</span>
              </p>
              <div class="scanIconDiv dfcjc mt10">
                <p>
                  <img src="../../../assets/img/scanIcon.png" alt />
                </p>
                <div class="ml10">
                  <p>打开手机支付宝</p>
                  <p>扫一扫继续付款</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tc mt10 font12">
          <a
            href="javascript:;"
            class="color99 firstUseAlipay"
            style="text-decoration:underline;"
            @click="downloadAilPay"
            >首次使用请下载手机支付宝</a
          >
        </div>
        <div style="position: absolute;top: 45px;right: 25px;">
          <img src="../../../assets/img/scan.png" alt />
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="aliPayDialog" :close-on-click-modal="false" width="640px" class="aliPayDialog">
      <div style="padding:20px 30px 40px;">
        <div class="color99 font16">手机扫码下载</div>
        <div class="aliPayContent mt10">
          <div class="mr30">
            <img class="qricon" src="https://t.alipayobjects.com/images/rmsweb/T1XjNgXX8XXXXXXXXX.png" />
          </div>
          <div class="downbtn">
            <p class="color99">下载到电脑</p>
            <a href="https://itunes.apple.com/cn/app/id333206289?mt=8" target="_blank" class="OSbtn">
              <img src="https://os.alipayobjects.com/rmsportal/DALvdsYTjvohprF.png" />
            </a>
            <a href="https://t.alipayobjects.com/L1/71/100/and/alipay_wap_main.apk" target="_blank" class="OSbtn">
              <img src="https://gw.alipayobjects.com/zos/rmsportal/oiQnUTKCYyqiKbHabDCW.png" />
            </a>
            <a
              href="http://www.windowsphone.com/zh-cn/store/app/%E6%94%AF%E4%BB%98%E5%AE%9D%E9%92%B1%E5%8C%85/8ce634b0-1861-4006-a31d-93c5a2c6073b"
              target="_blank"
              class="OSbtn"
            >
              <img src="https://os.alipayobjects.com/rmsportal/iYcyHkgBZDLjWhB.png" />
            </a>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      payDialogVisible: false,
      aliPayDialog: false,
      orderInfo: {}, //订单信息
      cost: 0, //实付金额,
      imageFwQrcode: "",
      loading: false,
      fwPackageType: 0, //套餐类型(产品套餐：0，图片套餐：1)
    };
  },
  mounted() {},
  methods: {
    //直接购买
    async show(arg) {
      let self = this;
      if (arg.hasOwnProperty("orderInfo")) {
        this.orderInfo = arg.orderInfo;
        this.fwPackageType = 0;
        let res = await this.getImageFwQrcode(this.orderInfo.planNo, 0);
        this.$emit("close", false);
        this.imageFwQrcode = res.url;
        this.imSign = res.imSign;
        this.cost = arg.orderInfo.cost;
        //dazeTask.login('KuaiO_FwPayCallBack_1')
      }
      this.payDialogVisible = true;
      this.checkIsPay();
    },
    //获取订单检测支付二维码
    getImageFwQrcode(planNo, fwCheckType) {
      return new Promise((resolve) => {
        this.$ajax
          .post("/kuaio/api/ForbiddenWord/PlanPay/GetPlanQrcode", {
            planNo,
            fwCheckType,
          })
          .then((res) => {
            if (res.code == 200) {
              let { result } = res;
              resolve(result);
            }
            if (res.code != 200) {
              this.$message.error(res.msg);
              resolve(false);
            }
          });
      });
    },
    // 获取支付二维码 qrcode
    GetPackageQrcode(prams) {
      this.loading = true;
      this.cost = prams.cost;
      this.$ajax
        .post("/kuaio/api/ForbiddenWord/PackagePay/GetPackageQrcode", {
          code: prams.code,
        })
        .then((res) => {
          if (res.code == 200) {
            let { result } = res;
            //resolve(result)
            this.payDialogVisible = true;
            this.$emit("close", false);
            this.imageFwQrcode = result.url;
            this.imSign = result.imSign;
            // console.log("获取到imSign=", result.imSign);
            // console.log("开始检测是否支付=", result.imSign);
            this.checkIsPay();
          }
          if (res.code == 999) {
            this.$message.error(res.msg);
          }
          this.loading = false;
        });
    },
    //检测 是否支付
    checkIsPay() {
      let self = this;
      // console.log("进入开始检测是否支付方法节点 this.$nextTick");
      this.$nextTick(() => {
        let key = this.imSign;
        let checkRes = this.$checkLogin();
        // console.log("checkRes 节点this.$nextTick里", checkRes);
        if (!checkRes) return;

        // console.log("dazeTask login 节点前", checkRes);
        dazeTask.login(key);
        //this.orderInfo.planNo
        dazeTask.register(key, function(data) {
          console.log(data);
          // console.log(data);
          if (data.PaySuccess) {
            self.$message.success({
              message: "支付成功",
              duration: 1200,
              onClose: () => {
                console.log(data);
                self.$emit("OnSuccess", data);
                self.payDialogVisible = false;
                self.$store.dispatch("GetFwPackageQuantity");
              },
            });
          }
        });
      });
    },
    closeWindow() {
      this.$emit("close", false);
      this.payDialogVisible = false;
    },
    //下载支付宝
    downloadAilPay() {
      this.aliPayDialog = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.payView {
  .payDialog {
    line-height: 1.4;
    .center {
      .scanDiv {
        border: 1px solid #e1e1e1;
        padding: 10px;
        .scanDivLoading {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        & /deep/ .el-loading-mask {
          background-color: rgba(0, 0, 0, 0);
        }
        & /deep/ .el-loading-spinner {
          background-color: rgba(0, 0, 0, 0);
        }
      }
    }
    .firstUseAlipay:hover {
      color: #999;
    }
  }
  .mb60 {
    margin-bottom: 60px;
  }
  .aliPayDialog {
    .aliPayContent {
      display: flex;
      align-items: baseline;
      .downbtn {
        .OSbtn {
          display: inline-block;
          width: 229px;
          height: 55px;
          margin-top: 8px;
          margin-bottom: 14px;
        }
      }
    }
  }
}
</style>
